/**
 * Module dependencies.
 */

import { apiEndpoints } from 'app/core/config/api-endpoints';
import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useQuery } from '@tanstack/react-query';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Export `useFetchVersions` hook.
 */

export function useFetchVersions() {
  const client = useRequestProvider();

  return useQuery({
    queryKey: ['translations-versions'],
    queryFn: async () => {
      const url = resolveAppUrl(apiEndpoints.translationsVersions, {});
      const response = await client.get(url, { withCredentials: true });
      return response.data?.data || response.data;
    }
  });
}
